export const homeConstants = {
  ALL_HOBBIES: "ALL_HOBBIES",
  ALL_CURRENCIES: "ALL_CURRENCIES",
  DEFAULT_CURRENCY: "DEFAULT_CURRENCY",
  ALL_ALLOWED_COUNTRIES: "ALL_ALLOWED_COUNTRIES",
  ALL_DAY_TO_DAY_ACTIVITY: "ALL_DAY_TO_DAY_ACTIVITY",
  ALL_MUST_HAVE_AMMENITIES: "ALL_MUST_HAVE_AMMENITIES",
};
